/* global axios */
import ApiClient from './ApiClient';

class AccountVoicesAPI extends ApiClient {
  constructor() {
    super('account_voices', { accountScoped: true });
  }

  clone(name, files) {
    const form = new FormData();
    form.append('name', name);
    files.forEach(f => form.append('samples[]', f));
    return axios.post(this.url, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new AccountVoicesAPI();
